import { Component, Inject, OnInit, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'app/core/interfaces/dialog';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { organizationI } from 'app/core/interfaces/organization';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { Medications, Prescription } from 'app/core/interfaces/prescriptions';
import { MedicationRequestService } from 'app/core/http/services/medicationrequest.service';

@Component({
  selector: 'page-schedule-details',
  templateUrl: './patient-previous-encounters-details.html',
  styleUrls: ['./patient-previous-encounters-details.scss'],
})
export class PatientPreviousEncounterDetails extends BaseComponent implements OnInit {
  public titleDados = 'Dados do Paciente';
  public organization: any = <organizationI>{};
  public encounter: any;
  public patient: any;
  public previousPrescriptions: Prescription[] = [];
  public prescriptions: Medications[] = [];

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector,
    private MedicationRequestService: MedicationRequestService
  ) {
    super(injector);
  }

  async ngOnInit() {
    let parameters = this.data.param;
    this.encounter = parameters.encounter;
    this.patient = parameters.patient;
    this.organization = this.encounter.organization;

    await this.getPatientPreviousPrescriptions();
  }

  async getPatientPreviousPrescriptions() {
    this.MedicationRequestService.showByEncounter(this.encounter.encounter_id).subscribe({
      next: (resPreviousPrescriptions: any) => {
        this.previousPrescriptions = resPreviousPrescriptions;
        this.prescriptions = this.previousPrescriptions[0].prescriptions;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
}
